enum numberOp {
  'eq' = 'eq',
  'not eq' = 'not eq',
  'gt' = 'gt',
  'gte' = 'gte',
  'lt' = 'lt',
  'lte' = 'lte',
}

enum mappedEventDataType {
  metadata,
  events,
}

enum mappedEventItemIndexType {
  tag_key = 'tag_key',
  tag_value = 'tag_value',
  event_name = 'event_name',
}

enum sortByType {
  ASC = 'asc',
  DESC = 'desc',
}

enum mappedEventStatusType {
  deployed = 'deployed',
  undeployed = 'undeployed',
}

enum mappedEventDimensionType {
  'all_event_name' = 'all_event_name',
  'conviva_event_name' = 'conviva_event_name',
  'custom_event_name' = 'custom_event_name',
  'merged_event_tag_key' = 'merged_event_tag_key',
  'merged_event_tag_value' = 'merged_event_tag_value',
}

enum EMappedEventDimension {
  'all_event_name' = 'all_event_name',
  'merged_event_tag_key' = 'merged_event_tag_key',
  'merged_event_tag_value' = 'merged_event_tag_value',
}

enum disshowDropdownDimensionType {
  'merged_event_tag_key' = 'merged_event_tag_key',
  'merged_event_tag_value' = 'merged_event_tag_value',
  'mapped_event' = 'mapped_event',
}

enum eventTypeOfMappedEvent {
  'all_event_name' = 'all_event_name',
  'conviva_event_name' = 'conviva_event_name',
  'custom_event_name' = 'custom_event_name',
}

enum ResetDimensionForMappedEvent {
  'mapped_event' = 'mapped_event',
  'event_category' = 'event_category',
}

enum ForbiddenEventNameOfFilter {
  'conviva_screen_view' = 'conviva_screen_view',
  'conviva_page_view' = 'conviva_page_view',
}

enum ConvivaEvent {
  'conviva_screen_view' = 'conviva_screen_view',
  'conviva_page_view' = 'conviva_page_view',
  'conviva_button_click' = 'conviva_button_click',
  'conviva_link_click' = 'conviva_link_click',
  'conviva_network_request' = 'conviva_network_request',
}

enum dimensionSelectedType {
  MappedEventSeleted,
  MappedEventUnseleted,
  CommonSeleted,
  CommonUnSeleted,
  dimensionSelectedType,
}

enum mappedEventDeployedStatus {
  deployed = 1,
  undeployed = 0,
}

enum AutofillStatus {
  CANNOT_AUTOFILL,
  CAN_AUTOFILL,
}

enum EventRuleItemType {
  NORMAL,
  PREDEFINE,
}

enum EEventManagementTabsType {
  MAPPED_EVENT = 'mapped-event',
  CUSTOM_DIMENSION = 'custom-dimension',
  METRICS = 'metrics',
  FLOWS = 'flows',
  KPI_SETTING = 'kpi-setting',
  BLOCKED_EVENT = 'blocked-event',
}

enum EEventSensorRemoteControlTabsType {
  BLOCKED_EVENT = 'blocked-event',
  BLOCKED_VIDEO_EVENT = 'blocked-video-event',
  CCS_CONFIGURATION = 'css-configuration',
  NETWORK_REQUEST_CONFIGURE = 'network-request-configure',
  CLICK_TRACKING = 'click-tracking',
  COLLECT_ATTRIBUTES = 'collect-attributes',
  CSS_SELECTORS_DEFAULT = 'css-selectors-default',
  CSS_SELECTORS_CUSTOM = 'css-selectors-custom',
  SESSION_REPLAY = 'session-replay',
  INTELLIGENT_COLLECTION = 'intelligent-collection',
}

enum EMetricsManagementTabsType {
  INDIVIDUAL_METRICS = 'individual_metric',
  METRICS_BY_FLOW = 'metrics_by_flow',
}

enum ERenamedDimension {
  'edited_page_title' = 'dt_1',
  'edited_screen_title' = 'dt_2',
}

enum EDataTransformDimensionName {
  'dt_1' = 'Edited Page Title',
  'dt_2' = 'Edited Screen Title',
}

enum ERenamePreset {
  PAGE = 'Page Views',
  SCREEN = 'Screen Views',
}

enum EDimensionType {
  CUSTOM_DIMENSION = 'custom_dimension',
  EVENT_ATTRIBUTE = 'event_attribute',
  MAPPED = 'mapped',
  ORIGINAL = 'original',
  USER_DEFINED = 'user_defined',
  PREDEFINED_CUSTOM_DIMENSION = 'predefined_custom_dimension',
}

enum ERenameTitle {
  PAGE = 'Page Title Rename',
  SCREEN = 'Screen Title Rename',
}

export {
  numberOp,
  mappedEventItemIndexType,
  mappedEventDataType,
  sortByType,
  mappedEventDimensionType,
  EMappedEventDimension,
  dimensionSelectedType,
  mappedEventStatusType,
  mappedEventDeployedStatus,
  disshowDropdownDimensionType,
  eventTypeOfMappedEvent,
  ResetDimensionForMappedEvent,
  ForbiddenEventNameOfFilter,
  AutofillStatus,
  EventRuleItemType,
  ConvivaEvent,
  EEventManagementTabsType,
  EMetricsManagementTabsType,
  ERenamedDimension,
  EDataTransformDimensionName,
  ERenamePreset,
  EDimensionType,
  ERenameTitle,
  EEventSensorRemoteControlTabsType,
};
